var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement(
      "g",
      { id: "navbar-likes-likes-icon-QuestionsTab", fill: "#1a1a1a", fillRule: "evenodd" },
      React.createElement("path", { d: "M28.5 0A19.53 19.53 0 0 0 9 19.5a19.26 19.26 0 0 0 2.27 9.1l-9.59 9.58a5.75 5.75 0 1 0 8.14 8.13l9.58-9.58A19.26 19.26 0 0 0 28.5 39a19.5 19.5 0 0 0 0-39zM7.69 44.19a2.8 2.8 0 0 1-3.88 0 2.74 2.74 0 0 1 0-3.89l9.1-9.1a19.91 19.91 0 0 0 3.89 3.89zM28.5 36A16.5 16.5 0 1 1 45 19.5 16.52 16.52 0 0 1 28.5 36z" }),
      React.createElement("path", { d: "M28.5 24.29a1.5 1.5 0 0 1-1.5-1.5v-2.9a1.5 1.5 0 0 1 1.5-1.5 2.05 2.05 0 1 0-2.05-2.05 1.5 1.5 0 0 1-3 0A5.05 5.05 0 1 1 30 21.16v1.63a1.5 1.5 0 0 1-1.5 1.5z" }),
      React.createElement("circle", { cx: "28.5", cy: "26.72", r: "1.5" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/icons/QuestionsTab.svg